import { WithCommonProps } from '@shipengine/giger';
import { getIntegrationGuideStyles } from './IntegrationGuideStyles';

export const IntegrationGuide: React.FC<WithCommonProps<unknown>> = ({
    children,
}: WithCommonProps<unknown>): JSX.Element => {
    return <aside css={getIntegrationGuideStyles}>{children}</aside>;
};
